import commonConstants from "./commonConstants";

const desktopConstants = {
  ...commonConstants,
} as const;

export default desktopConstants;
